<h3 class="flex mb-3 gap-2 padding justify-content-between">
  Campaign Scoring

  <tux-button
    (clicked)="save()"
    type="primary"
    [isDisabled]="
      (form.value.scoringType === scoringTypes.percent &&
        (isOutOfLimit$ | async)) ||
      form.pristine
    "
    >Save</tux-button
  >
</h3>

<div class="card padding">
  <div class="flex mb-3 gap-2 justify-content-start">
    <div class="flex align-items-center">
      <p-radioButton
        name="scoringType"
        [value]="0"
        [formControl]="form.controls.scoringType"
        inputId="percent"
      />
      <label for="percent" class="ml-2"> Percent </label>
    </div>
    <div class="flex align-items-center">
      <p-radioButton
        name="scoringType"
        [value]="1"
        [formControl]="form.controls.scoringType"
        inputId="customWeight"
      />
      <label for="customWeight" class="ml-2"> Custom Weight </label>
    </div>
  </div>
  <p-accordion [activeIndex]="form.controls.scoringType.value">
    <p-accordionTab header="Percent" [disabled]="true">
      <div class="card flex gap-3 p-fluid">
        <div class="flex-auto">
          <label class="mb-2 block font-bold" for="firstTouch">
            First Touch
          </label>
          <p-inputNumber
            class="w-full"
            [showButtons]="true"
            [formControl]="form.controls.percent.controls.firstTouch"
            [min]="0"
            buttonLayout="horizontal"
            inputId="firstTouch"
            spinnerMode="horizontal"
            [step]="1"
            decrementButtonClass="p-button-secondary"
            incrementButtonClass="p-button-secondary"
          />
        </div>
        <div class="flex-auto">
          <label class="mb-2 block font-bold" for="lastTouch">
            Last Touch
          </label>
          <p-inputNumber
            class="w-full"
            [showButtons]="true"
            [formControl]="form.controls.percent.controls.lastTouch"
            [min]="0"
            buttonLayout="horizontal"
            inputId="lastTouch"
            spinnerMode="horizontal"
            [step]="1"
            decrementButtonClass="p-button-secondary"
            incrementButtonClass="p-button-secondary"
          />
        </div>
        <div class="flex-auto">
          <label class="mb-2 block font-bold" for="otherTouches">
            Other Touches
          </label>
          <p-inputNumber
            class="w-full"
            [showButtons]="true"
            [formControl]="form.controls.percent.controls.otherTouches"
            [min]="0"
            buttonLayout="horizontal"
            inputId="otherTouches"
            spinnerMode="horizontal"
            [step]="1"
            decrementButtonClass="p-button-secondary"
            incrementButtonClass="p-button-secondary"
          />
        </div>
      </div>
      <div class="card">
        <p-meterGroup
          [value]="(percentMeter$ | async)?.meter!"
          [max]="(percentMeter$ | async)?.max!"
          labelPosition="start"
        >
          <ng-template #label>
            <div class="flex flex-wrap gap-3">
              <ng-container
                *ngFor="
                  let meterItem of (percentMeter$ | async)?.meter;
                  let index = index
                "
              >
                <p-card class="flex-1">
                  <div class="flex justify-content-between gap-5">
                    <div class="flex flex-column gap-1">
                      <span class="text-secondary text-sm">{{
                        meterItem.label
                      }}</span>
                      <span class="font-bold text-lg"
                        >{{ meterItem.value }}%</span
                      >
                    </div>
                    <span
                      class="w-2rem h-2rem border-circle inline-flex justify-content-center align-items-center text-center"
                      [style]="{
                        'background-color': meterItem.color,
                        color: '#ffffff'
                      }"
                    >
                      <i [class]="meterItem.icon"></i>
                    </span>
                  </div>
                </p-card>
              </ng-container>
            </div>
          </ng-template>
        </p-meterGroup>
      </div>
    </p-accordionTab>
    <p-accordionTab header="Custom Weight" [disabled]="true">
      <div class="flex gap-5">
        <div class="card-group">
          <p-card header="Channel">
            <lib-scoring-input-range
              *ngFor="let revenue of revenues$ | async"
              [control]="
                form.controls.customWeight.controls.channel.controls[revenue]
              "
              [label]="revenue"
              [model]="ngModels.customWeight.channel"
              [modelKey]="revenue"
            ></lib-scoring-input-range>
          </p-card>
        </div>
        <div class="card-group">
          <p-card header="Touch Point Position">
            <lib-scoring-input-range
              [control]="
                form.controls.customWeight.controls.touchPosition.controls
                  .sourceTouch
              "
              label="Source Touch"
              [model]="ngModels.customWeight.touchPosition"
              modelKey="sourceTouch"
            ></lib-scoring-input-range>
            <lib-scoring-input-range
              [control]="
                form.controls.customWeight.controls.touchPosition.controls
                  .opptyConversionTouch
              "
              label="Oppty Conversion Touch"
              [model]="ngModels.customWeight.touchPosition"
              modelKey="opptyConversionTouch"
            ></lib-scoring-input-range>
          </p-card>
          <p-card header="Time Decay">
            <div class="control flex align-items-center">
              <p-radioButton
                name="timeDecay"
                [value]="0"
                [formControl]="
                  form.controls.customWeight.controls.timeDecay.controls
                    .duration
                "
                inputId="fullCredit"
              />
              <label for="fullCredit" class="ml-2"> Give full credit: </label>
            </div>
            <div class="control flex align-items-center">
              <p-radioButton
                name="timeDecay"
                [value]="1"
                [formControl]="
                  form.controls.customWeight.controls.timeDecay.controls
                    .duration
                "
                inputId="halfDay"
              />
              <label for="halfDay" class="ml-2"> Use a half life decay: </label>
            </div>
            <div
              class="control flex align-items-center"
              *ngIf="
                form.controls.customWeight.controls.timeDecay.controls.duration
                  .value === 1
              "
            >
              <div class="flex-auto">
                <label class="mb-2 block font-bold" for="monthsOfHalfLife">
                  Months for half life decay:
                </label>
                <p-inputNumber
                  [showButtons]="true"
                  [formControl]="
                    form.controls.customWeight.controls.timeDecay.controls
                      .monthsOfHalfLife
                  "
                  [min]="0"
                  [max]="18"
                  buttonLayout="horizontal"
                  inputId="monthsOfHalfLife"
                  spinnerMode="horizontal"
                  [step]="1"
                  decrementButtonClass="p-button-secondary"
                  incrementButtonClass="p-button-secondary"
                />
              </div>
            </div>
          </p-card>
          <p-card header="Attributed Touch Type">
            <div class="control">
              <span>Opportunity Contact Role</span>
              <div
                class="card flex justify-content-center align-items-center gap-5"
              >
                <p-slider
                  class="w-full"
                  [step]="1"
                  [min]="0"
                  [max]="10"
                  [(ngModel)]="
                    ngModels.customWeight.touchType.opportunityContactRole
                  "
                  [formControl]="
                    form.controls.customWeight.controls.touchType.controls
                      .opportunityContactRole
                  "
                  [disabled]="
                    !!form.controls.customWeight.controls.touchType.controls
                      .contactRoleOverride.value
                  "
                />
                <p-inputNumber
                  [(ngModel)]="
                    ngModels.customWeight.touchType.opportunityContactRole
                  "
                  [showButtons]="true"
                  [formControl]="
                    form.controls.customWeight.controls.touchType.controls
                      .opportunityContactRole
                  "
                  [min]="0"
                  [max]="10"
                  buttonLayout="horizontal"
                  inputId="lastTouch"
                  spinnerMode="horizontal"
                  [step]="1"
                  decrementButtonClass="p-button-secondary"
                  incrementButtonClass="p-button-secondary"
                  [disabled]="
                    !!form.controls.customWeight.controls.touchType.controls
                      .contactRoleOverride.value
                  "
                />
              </div>
            </div>

            <div class="control">
              <div class="flex align-items-center gap-2">
                <p-checkbox
                  name="permissions"
                  inputId="contact_role_override"
                  [binary]="true"
                  (onChange)="onOcrOverrideChange($event)"
                  [formControl]="
                    form.controls.customWeight.controls.touchType.controls
                      .contactRoleOverride
                  "
                >
                </p-checkbox>
                <label for="contact_role_override"
                  >: Use Opportunity Contact Role Override</label
                >
              </div>
            </div>

            <p-card
              *ngIf="
                form.controls.customWeight.controls.touchType.controls
                  .contactRoleOverride.value
              "
            >
              <lib-scoring-input-range
                *ngFor="let role of roles$ | async"
                [control]="
                  form.controls.customWeight.controls.ocrRole.controls[role]
                "
                [label]="role"
                [model]="ngModels.customWeight.ocrRole"
                [modelKey]="role"
              ></lib-scoring-input-range>
            </p-card>

            <lib-scoring-input-range
              [control]="
                form.controls.customWeight.controls.touchType.controls
                  .accountContact
              "
              label="Account Contact"
              [model]="ngModels.customWeight.touchType"
              modelKey="accountContact"
            ></lib-scoring-input-range>

            <lib-scoring-input-range
              [control]="
                form.controls.customWeight.controls.touchType.controls
                  .orphanLead
              "
              label="Orphan Lead"
              [model]="ngModels.customWeight.touchType"
              modelKey="orphanLead"
            ></lib-scoring-input-range>
          </p-card>
        </div>
      </div>
    </p-accordionTab>
  </p-accordion>
</div>
